// Petit module dédié à la persistance debounced de l'éditeur de questionnaire dans le
// localStorage. Volontairement séparé de studea-manager-questionnaire.js (store Pinia, avec sa
// propre chaîne de dépendances vers questionnaireManager / notificationManager / @/main) afin que
// storage-manager.js — importé très tôt par user-manager.js, lui-même importé par @/main — puisse
// annuler le debounce sans provoquer de dépendance circulaire vers @/main.
export const QUESTIONNAIRE_EDITOR_STORAGE_KEY = "studea-questionnaireEditor";
const QUESTIONNAIRE_EDITOR_STORAGE_DEBOUNCE_DELAY = 400;

let persistQuestionnaireEditorTimer;

// Écrit l'éditeur de questionnaire dans le localStorage après un court silence (debounce),
// pour éviter une écriture synchrone à chaque mutation (ajout/suppression/duplication de bloc).
export function persistQuestionnaireEditor(questionnaire) {
  clearTimeout(persistQuestionnaireEditorTimer);
  persistQuestionnaireEditorTimer = setTimeout(() => {
    window.localStorage.setItem(QUESTIONNAIRE_EDITOR_STORAGE_KEY, JSON.stringify(questionnaire));
  }, QUESTIONNAIRE_EDITOR_STORAGE_DEBOUNCE_DELAY);
}

// À appeler juste avant toute purge synchrone de la clé QUESTIONNAIRE_EDITOR_STORAGE_KEY
// (logout, abandon sans sauvegarde…) pour éviter qu'un debounce déjà lancé ne réécrive
// le brouillon juste après le removeItem.
export function cancelPersistQuestionnaireEditor() {
  clearTimeout(persistQuestionnaireEditorTimer);
}
